import { rem } from 'polished'

export const LABEL_HEIGHT = rem(24)
export const MIN_LABEL_HEIGHT = rem(24)
